import { render, staticRenderFns } from "./BoxTypeSelect.vue?vue&type=template&id=77237f0e&scoped=true&"
import script from "./BoxTypeSelect.vue?vue&type=script&lang=js&"
export * from "./BoxTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./BoxTypeSelect.vue?vue&type=style&index=0&id=77237f0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77237f0e",
  null
  
)

export default component.exports